import { Stack, TextField } from '@fluentui/react';

type Props = {
  label: string;
  value: string;
  onChange: (value: string) => void;
  required?: boolean;
  className?: any;
};

const TextInput = ({ label, value, onChange, required, className }: Props) => {
  return (
    <Stack style={{ marginBottom: '8px' }}>
      <label style={{ marginBottom: '2px' }}>
        {label}
        {required && <sup style={{ color: 'red' }}>*</sup>}
      </label>
      <TextField
        className={className}
        type="text"
        value={value}
        onChange={(_, val) => onChange(val ?? '')}
        onKeyUp={e => onChange(e.currentTarget.value)}
      />
    </Stack>
  );
};

export default TextInput;
